<template>
  <div class="calibration_select_container">
    <div class="mgx_top_right_fixed">
      <div class="top_right_btn mgx_action_btn ghost" @click="back">
        <span class="btn_text">{{ $t('back_calibration') }}</span>
      </div>
    </div>

    <div class="calibration_container">
      <div class="calibration_select_mode_device">
        <Virtual_devices></Virtual_devices>
      </div>
    </div>
    <div class="calibration_select_mode">
      <div class="select_mode_title">{{ $t('calibration_select_mode') }}</div>
      <div class="select_modes">
        <div class="mode_button button ghost" @click="singleEvent" v-if="isShowSingle">{{ $t('calibration_select_mode_single') }}</div>
        <div class="mode_button button ghost" @click="allEvent">{{ $t('calibration_select_mode_all') }}</div>
      </div>
    </div>
  </div>
</template>
<script setup lang="ts">
import { DeviceManager } from '@/service/device'
import { compare } from 'compare-versions'
import { computed, onUnmounted } from 'vue'
import { calibrationHandler } from '@/service/driver/calibration_set'
import Virtual_devices from '../device/virtual_devices.vue'
import { DevicePid } from '@/define/define'

const back = () => (calibrationHandler.state.isShowCalibrationSelect = false)
onUnmounted(() => {
  if (DeviceManager.instance.state.currentPid === DevicePid.None) {
    back()
  }
})
const isShowSingle = computed(() => {
  return DeviceManager.instance.state.driverServiceVersion != null && compare(DeviceManager.instance.state.driverServiceVersion, '2.1.1', '>=')
})

const allEvent = () => {
  calibrationHandler.state.isShowExeAllCalibration = true
  calibrationHandler.state.isShowCalibrationSelect = false
}
const singleEvent = () => {
  calibrationHandler.state.isShowExeSingleCalibration = true
  calibrationHandler.state.isShowCalibrationSelect = false
}
</script>

<style scoped lang="less">
.calibration_select_container {
  width: 100%;
  height: 100%;
  z-index: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.calibration_select_mode_device {
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 20px 0;

  :deep(.board_view) {
    transform: scale(1.2);
    transform-origin: center;
    background: var(--glass-ghost-bg);
    backdrop-filter: var(--glass-ghost-blur);
    border: 1px solid var(--glass-ghost-border);
    border-radius: var(--radius-l);
    padding: 20px;
  }

  :deep(.texture) {
    color: var(--color-dark) !important;
    font-weight: 700;
  }
}

.calibration_select_mode {
  margin-top: 40px;

  .select_mode_title {
    text-align: center;
    font-size: 22px;
    color: #fff;
  }

  .select_modes {
    margin-top: 42px;
    display: flex;
    justify-content: center;

    .mode_button {
      &:first-child {
        margin-right: 32px;
      }

      padding: 0 48px;
      min-width: 160px;
      height: 48px;
      font-size: 16px;
      font-weight: bold;
    }
  }
}
</style>
